import { definedMap, dontAwait } from "@glideapps/ts-necessities";

import { defined } from "common/Support";
import { asString } from "common/components/component-helpers";
import { LOADING, ActionSource } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import NotePreview from "../ui/views/note-preview/note-preview";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";
import { useNetworkStatus } from "hooks/use-network-status";

export const NoteMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [
        [placeholder, text, onChangeValue, onTapValue, isEnabledValue, title, isRequired],
        [, textValueProducer],
    ] = useForceValueProducers(getValueProducers, force, ctx);
    const { onClick: onClickCB } = useOnClickFromAction(onTapValue, ActionSource.Note, ctx, env);
    const { onClick: onChangeCB } = useOnClickFromAction(onChangeValue, ActionSource.Note, ctx, env);
    const onLine = useNetworkStatus();

    if (text === LOADING || placeholder === LOADING || title === LOADING) return env.renderProgress();

    const onChange = (newValue: string) => {
        defined(textValueProducer).set(newValue);
        if (onChangeCB !== undefined) {
            dontAwait(onChangeCB(undefined));
        }
    };

    const onTap =
        onClickCB !== undefined
            ? () => {
                  dontAwait(onClickCB(undefined));
              }
            : undefined;

    const isEnabled = onLine && (onChangeCB === undefined || isEnabledValue !== false);

    return (
        <NotePreview
            renderEnvironment={env}
            onSave={onChange}
            onTap={onTap}
            note={definedMap(text, asString)}
            placeholder={definedMap(placeholder, asString)}
            title={definedMap(title, asString)}
            isEnabled={isEnabled}
            isRequired={isRequired === true}
        />
    );
};
